import { FC } from 'react'

import { RenderWhen } from 'cng-common/components/renderWhen'
import { Translation } from 'cng-common/features/translations'
import { Input } from 'core-components/library/inputs'

import styles from './FocusField.module.scss'

interface IFocusFieldProps {
  isEditMode: boolean
  focus: string
  focusLabel: string
  onFocusChange: (focus: string) => void
  suppliersLabel: string
  suppliers: string
}

export const FocusField: FC<IFocusFieldProps> = ({
  isEditMode,
  focus,
  focusLabel,
  onFocusChange,
  suppliers,
  suppliersLabel,
}) => {
  return (
    <div className={styles.root}>
      <RenderWhen condition={isEditMode}>
        <Input label={<Translation text={focusLabel} />} value={focus} onChange={onFocusChange} />
      </RenderWhen>
      <RenderWhen condition={!isEditMode}>
        <div className={styles.root}>
          <div className={styles.focus}>{focus}</div>
          <div className={styles.arrow}>
            <i className="kbase kbase-arrow-right" />
          </div>
          <div className={styles.suppliers}>
            <Translation
              span
              text={suppliersLabel}
              replaceParams={[
                {
                  key: '{suppliers}',
                  value: suppliers,
                },
              ]}
            />
          </div>
        </div>
      </RenderWhen>
    </div>
  )
}
